import type React from 'react'
import type { JSX } from 'react'
import type { IPrimaryButtonProps } from 'atoms/Button/Templates'
import type { ITextBlockDescriptionForSpecialRowCenterProps } from 'blocks/TextBlock/Templates'
import type { IContainerDescriptionProps } from '../ContainerDescription'

import { PrimaryButton } from 'atoms/Button/Templates'
import { TextBlockDescriptionForSpecialRowCenter } from 'blocks/TextBlock/Templates/Descriptions/TextBlockDescriptionForSpecialRowCenter'
import { FIXED_INDENTS } from 'vars/index'
import { ContainerDescription } from '../ContainerDescription'
import {
  ContainerDescriptionAlignItems,
  ContainerDescriptionRowGap,
} from '../ContainerDescription.h'

export interface IContainerDescriptionForSpecialRowCenteredProps extends Omit<
  IContainerDescriptionProps,
  'children'
> {
  children?: React.ReactNode
  title?: ITextBlockDescriptionForSpecialRowCenterProps['title']
  description?: ITextBlockDescriptionForSpecialRowCenterProps['description']
  buttonTitle?: IPrimaryButtonProps['title']
  isButtonShown?: boolean
  onSeeAllClick?: () => void
}

export const ContainerDescriptionForSpecialRowCenter = ({
  title = '',
  description = '',
  buttonTitle = '',
  isButtonShown = false,
  alignItems = ContainerDescriptionAlignItems.Center,
  rowGap = ContainerDescriptionRowGap.INDENT_40,
  children,
  paddings = [
    FIXED_INDENTS.INDENT_60,
    FIXED_INDENTS.INDENT_0,
    FIXED_INDENTS.INDENT_0,
  ],
  onSeeAllClick,
  ...rest
}: IContainerDescriptionForSpecialRowCenteredProps): JSX.Element => {
  return (
    <ContainerDescription
      alignItems={alignItems}
      rowGap={rowGap}
      paddings={paddings}
      {...rest}
    >
      <TextBlockDescriptionForSpecialRowCenter
        title={title}
        description={description}
        width={100}
      />
      {children ? (
        children
      ) : isButtonShown && buttonTitle ? (
        <PrimaryButton onClick={onSeeAllClick} title={buttonTitle} />
      ) : null}
    </ContainerDescription>
  )
}

ContainerDescriptionForSpecialRowCenter.displayName =
  'ContainerDescriptionForSpecialRowCenter'
